const About = () => {
  const name = 'Hal Barnett';
  return (
    <div>
      <h2 className="mb-4">About {name}</h2>
      <p>
        I&apos;m a self-staring software developer with a passion for building
        web applications and learning new technologies. I enjoy working with
        modern frameworks and libraries to create efficient and user-friendly
        experiences.
      </p>
      <dl>
        <dt>Todo list app:</dt>
        <dd>
          Uses React, TypeScript, Vite and Zustand (for state):&nbsp;
          <a
            href="https://github.com/otherblandart/todo-app"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>
          &nbsp; | &nbsp;
          <a href="/todos" target="_blank">
            Demo
          </a>
        </dd>
      </dl>
    </div>
  );
};

export default About;
